import { Flex, Grid, Input, Paper, Space, Text } from "@mantine/core";
import { useSelector } from "react-redux";
import { IGeneral } from "../../interfaces/IGeneral";
import { IReference } from "../../models/General";
import { currencyFormat } from "../../utils";
import { dateTimeFormat } from "../../utils/date";
import { Tag } from "../tags";

export const RequestInvoiceTab = ({ action }: { action: any[] }) => {
  const { invoiceStatus, invoicePaymentStatus, invoiceOverdueStatus } = useSelector((state: { general: IGeneral }) => state.general);
  const data = action[1] && { ...action[1] };

  return (
    <Paper py={"lg"}>
      <Text color="gray.8" fw={600}>
        Ерөнхий мэдээлэл
      </Text>
      <Space h={"lg"} />
      <Grid>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Нэхэмжлэхийн код">
            <div>
              <Text component="span" fz={"sm"} color="golomt">
                # {data?.invoice?.refCode || "-"}
              </Text>
            </div>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Нэхэмжлэх илгээсэн">
            <Text>
              <Text fz={"sm"} color="golomt" component="span" tt={"capitalize"}>
                {data?.invoice?.senderUser?.lastName ? data?.invoice?.senderUser?.lastName[0] + ". " : ""} {data?.invoice?.senderUser?.firstName || "-"}{" "}
              </Text>
              <Text fz={"sm"} component="span">
                {data?.invoice?.sentDate ? dateTimeFormat(data?.invoice?.sentDate) : "-"}
              </Text>
            </Text>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Нэхэмжлэх баталсан">
            <div>
              <Text component="span" fz={"sm"} color="golomt" tt={"capitalize"}>
                {data?.invoice?.confirmedUser?.lastName ? data?.invoice?.confirmedUser?.lastName[0] + ". " : ""}{" "}
                {data?.invoice?.confirmedUser?.firstName || "-"}{" "}
              </Text>
              <Text fz={"sm"} component="span">
                {data?.invoice?.confirmedDate ? dateTimeFormat(data?.invoice?.confirmedDate) : "-"}
              </Text>
            </div>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Баталсан дүн">
            <div>
              <Text component="span" fz={"sm"} color="golomt">
                {currencyFormat(data?.invoice?.confirmedAmount)}
              </Text>
            </div>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Төлсөн дүн">
            <div>
              <Text component="span" fz={"sm"} color="golomt">
                {currencyFormat(data?.invoice?.paidAmount)}
              </Text>
            </div>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Нэхэмжлэхийн үлдэгдэл">
            <div>
              <Text component="span" fz={"sm"} color="golomt">
                {currencyFormat(data?.invoice?.amountToPay)}
              </Text>
            </div>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Нэхэмжлэх төлөв">
            <div>
              {Tag(
                invoiceStatus?.find((item: IReference) => item.code === data?.invoice?.invoiceStatus)?.color || "gray",
                invoiceStatus?.find((item: IReference) => item.code === data?.invoice?.invoiceStatus)?.name || "-",
              )}
            </div>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Төлбөрийн төлөв">
            <div>
              {Tag(
                invoicePaymentStatus?.find((item: IReference) => item.code === data?.invoice?.paymentStatus)?.color || "gray",
                invoicePaymentStatus?.find((item: IReference) => item.code === data?.invoice?.paymentStatus)?.name || "-",
              )}
            </div>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Хугацаа хэтрэлтийн төлөв">
            <div>
              {Tag(
                invoiceOverdueStatus?.find((item: IReference) => item.code === data?.invoice?.overdueStatus)?.color || "gray",
                invoiceOverdueStatus?.find((item: IReference) => item.code === data?.invoice?.overdueStatus)?.name || "-",
              )}
            </div>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Төлбөрийн нөхцөл">
            <div>
              <Text component="span" fz={"sm"} color="golomt">
                {data?.invoice?.paymentTermDesc || "-"}
              </Text>
            </div>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Нэхэмжлэх төлөх огноо">
            <div>
              <Text component="span" fz={"sm"} color="golomt">
                {data?.invoice?.paymentDate ? dateTimeFormat(data?.invoice?.paymentDate) : "-"}
              </Text>
            </div>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Нэхэмжлэхийн баримт">
            <div>
              <Text component="span" fz={"sm"}>
                _{data?.refCode}_.pdf
              </Text>
            </div>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col>
          <Text color="gray.8" fw={600}>
            Нийлүүлэгч талын мэдээлэл
          </Text>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Партнерийн нэр">
            <Flex gap={8} align={"center"}>
              <Text component="span" fz={"sm"}>
                {data?.invoice?.supplier?.partner?.businessName || "-"},
              </Text>
              <Text fz={"sm"} component="span" color="golomt">
                # {data?.invoice?.supplier?.partner?.refCode || "-"},
              </Text>
            </Flex>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Татвар төлөгчийн дугаар">
            <div>
              <Text component="span" fz={"sm"} color="golomt">
                {data?.invoice?.supplier?.regNumber || "-"}
              </Text>
            </div>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Нийлүүлэгч бизнес">
            <Flex gap={8}>
              <Text component="span" fz={"sm"}>
                {data?.invoice?.supplier?.profileName || "-"},
              </Text>
              <Text component="span" fz={"sm"} color="golomt">
                # {data?.invoice?.supplier?.refCode || "-"}
              </Text>
            </Flex>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Нийлүүлэгчийн данс">
            <Flex gap={8} align={"end"}>
              <Text component="span" fz={"sm"} color="golomt">
                {data?.invoice?.supplierAccount?.number || "-"},
              </Text>
              <Text component="span" fz={"sm"}>
                {data?.invoice?.supplierAccount?.name || "-"}, {data?.invoice?.supplierAccount?.bankName || "-"},
              </Text>
              <Text component="span" fz={"xs"} color="gray">
                ({data?.invoice?.supplierAccount?.shortName || "-"})
              </Text>
            </Flex>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Борлуулалтын захиалга">
            <Flex gap={8}>
              <Text component="span" fz={"sm"} color="golomt">
                {data?.invoice?.orderSalesCode || "-"}
              </Text>
            </Flex>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Санхүүгийн ажилтан">
            <Flex gap={8}>
              <Text component="span" fz={"sm"} color="golomt" tt={"capitalize"}>
                {data?.invoice?.supplierFinUser?.lastName ? data?.invoice?.supplierFinUser?.lastName[0] + ". " : ""}{" "}
                {data?.invoice?.supplierFinUser?.firstName || "-"}
              </Text>
            </Flex>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col>
          <Text color="gray.8" fw={600}>
            Худалдан авагчийн мэдээлэл
          </Text>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Партнерийн нэр">
            <Flex gap={8}>
              <Text fz="sm">{data?.invoice?.buyer?.partner?.businessName || "-"}</Text>
              <Text fz="sm" color="golomt">
                #{data?.invoice?.buyer?.partner?.refCode || "-"}
              </Text>
            </Flex>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Татвар төлөгчийн дугаар">
            <Flex gap={8}>
              <Text component="span" fz={"sm"} color="golomt">
                {data?.invoice?.buyer?.regNumber || "-"}
              </Text>
            </Flex>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Худалдан авагч бизнес">
            <Flex align={"center"} gap={8}>
              <Text fz="sm">{data?.invoice?.buyer?.profileName || "-"},</Text>
              <Text fz="sm" color="golomt">
                #{data?.invoice?.buyer?.refCode || "-"}
              </Text>
            </Flex>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Худалдан авагчийн данс">
            <Flex columnGap={8} align={"end"} wrap={"wrap"}>
              <Text component="span" fz={"sm"} color="golomt">
                {data?.invoice?.buyerAccount?.number || "-"}
              </Text>
              <Text component="span" fz={"sm"}>
                , {data?.invoice?.buyerAccount?.name || "-"}, {data?.invoice?.buyerAccount?.bankName || "-"}{" "}
              </Text>
              <Text component="span" fz={"xs"} color="gray">
                ({data?.invoice?.buyerAccount?.shortName || "-"})
              </Text>
            </Flex>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Худалдан авалтын захиалга">
            <div>
              <Text component="span" fz={"sm"} color="golomt">
                {data?.invoice?.purchaseOrder?.refCode || "-"}
              </Text>
            </div>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper label="Санхүүгийн ажилтан">
            <div>
              <Text component="span" fz={"sm"} tt={"capitalize"} c={"golomt"}>
                {data?.invoice?.buyerFinUser?.lastName ? data?.invoice?.buyerFinUser?.lastName[0] + ". " : ""} {data?.invoice?.buyerFinUser?.firstName || "-"}
              </Text>
            </div>
          </Input.Wrapper>
        </Grid.Col>
        {/* <Grid.Col>
          <Code>
            <pre>{JSON.stringify(action, null, 2)}</pre>
          </Code>
        </Grid.Col> */}
      </Grid>
    </Paper>
  );
};
